import PropTypes from 'prop-types';
import { Component } from 'react';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import CreateSalesforceTaskActionMetadata from 'automation-ui-action-features/actions/create-salesforce-task/CreateSalesforceTaskActionMetadata';
import CreateSalesforceTaskActionDetail from 'automation-ui-action-features/actions/create-salesforce-task/CreateSalesforceTaskActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class CreateSalesforceTaskActionHistoryCard extends Component {
  render() {
    const {
      actionMetadata,
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(CreateSalesforceTaskActionDetail, {
        actionMetadata: actionMetadata
      })
    });
  }
}
CreateSalesforceTaskActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(CreateSalesforceTaskActionMetadata).isRequired,
  actionLabel: PropTypes.node
};
export default CreateSalesforceTaskActionHistoryCard;